export default {"src":"/_next/static/media/error_info.ab569b70.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};